import React from "react";
import { ThemeProvider } from "styled-components";
import defaultTheme from "../styles/theme";

const withTheme = (Component) => {
  return (props) => (
    <ThemeProvider theme={defaultTheme}>
      <Component {...props} />
    </ThemeProvider>
  );
};
export { withTheme };
